import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'ftsec',  label: 'ft³ / sec' },
  { key: 'msec',   label: 'm³ / sec' },
  { key: 'glsec',  label: 'gal / sec' },
  { key: 'litsec', label: 'l / sec' },
  { key: 'ftday',  label: 'ft³ / day' },
  { key: 'mday',   label: 'm³ / day' },
  { key: 'glday',  label: 'gal / day' },
  { key: 'litday', label: 'l / day' },
];

// Base: ft³/sec
const factors = {
  ftsec:  1,
  msec:   1 / 35.315,
  glsec:  7.481,
  litsec: 28.317,
  ftday:  86400,
  mday:   2446.576,
  glday:  646316.883,
  litday: 2446575.5,
};

export const ConvDischarge = () => (
  <UnitConverter
    title="Discharge"
    units={units}
    factors={factors}
    explanationTitle="Units of discharge"
    explanation="1 gal/sec = 3.785 litres. In the English system, the gallon per second is approximately 3.785 times a litre of discharge in the metric system."
  />
);
